import React from 'react';

const Models = () => {
  return (
    <div className='flex justify-center items-center text-black font-semibold h-screen'>
      <h1 className='text-4xl'>MODELS FEATURES COMING SOON <span className='text-red-600'>(IN PROGRESS)</span></h1>
    </div>
  )
};

export default Models;
